import { KTCard } from '../../../../_metronic/helpers'
import { Card4 } from '../../../../_metronic/partials/content/cards/Card4'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import React from 'react'
import { useAuth } from '../../auth'

const Menu = () => {
    const { isSupplyChainManager, currentUser } = useAuth()
    const features = [
        { name: 'Material Hub', icon: 'FTS Material Hub icon', to: 'user-information' },
        { name: 'Incentive', icon: 'FTS Incentives', to: 'user-incentive' },
        // { name: 'Compliance', icon: 'capi', to: 'compliance' },
        // { name: 'Capacity', icon: 'comi', to: 'processing-capacity' },

        ...(!isSupplyChainManager ? [
            { name: 'Compliance', icon: 'capi', to: 'compliance' },
            { name: 'Activity', icon: 'comi', to: 'processing-capacity' },
        ] : []),

        ...((isSupplyChainManager && [
            {
                name: 'Supply chains',
                icon: 'FTS Supply Chai icon',
                to: 'supply-chains',
            },
        ]) ||
            []),
        // { name: 'Purchase Order', icon: 'purchase order', to: 'purchase-orders' },

        ...(!['CLIENT', 'FRANCHISE_USER', 'CLIENT_USER', "MARKETING", "PICKUP_POINT_STAFF"].includes((currentUser as any)?.userType) && [
            { name: 'Purchase order', icon: 'purchase order', to: 'purchase-orders' }
        ] || []),

        ...(((currentUser as any)?.userType === "PICKUP_POINT_STAFF" && [
            { name: 'Payables', icon: 'payments', to: 'payables-facility' },
            { name: 'Receivables', icon: 'cp', to: 'receivables-facility' },
        ]) ||
            []),
    ]
    return (
        <KTCard addCard={false}>
            <div className='row g-xl-4'>
                {features.map((eachFeatures, eachIndex) => (
                    <div key={eachIndex + 1 + ''} className='col col-lg-2'>
                        <Link className={clsx('menu-link without-sub')} to={eachFeatures.to}>
                            <Card4
                                // icon={`/media/svg/files/${eachFeatures.icon}.png`}
                                icon={`/media/svg/files/${eachFeatures.icon}.png`}
                                title={eachFeatures.name}
                                description=''
                            />
                        </Link>
                    </div>
                ))}
            </div>
        </KTCard>
    )
}

const FacilityMenu = () => <Menu />

export { FacilityMenu }
